<template>
  <div class="grid row">

    <!-- The modal window to invoke the Invite New User. It supports by default only add operation -->
    <va-modal v-model="showInviteUserModal" overlay-opacity="0.2" size="large" hide-default-actions blur>
      <template #header>
        <h2>{{ inviteUser.title }}</h2>
      </template>
      <InviteUserModal :title="inviteUser.title" :options="inviteUser.options" :selectedEntity="inviteUser.selectedEntity"
        @close="close" />
    </va-modal>

    <!-- The Modal window to invoke the group detail. It supports by default Add and Edit operations -->
    <va-modal v-model="showAddGroupModal" overlay-opacity="0.2" size="large" hide-default-actions blur>
      <template #header>
        <h2>{{ title }}</h2>
      </template>
      <div v-if="editGroup">
        <AddGroupModal :title="title" :industry_id="editGroup.industry_id" :entity_id="editGroup.entity_id"
          :usergroup_name="editGroup.usergroup_name" :usergroup_description="editGroup.usergroup_description"
          :usergroup_id="editGroup.usergroup_id" @close="close" />
      </div>
      <div v-else>
        <AddGroupModal :title="title" @close="close" />
      </div>
    </va-modal>

    <div class="flex xs12 md12" style="width: 90% !important;">
      <va-card style="overflow-x: auto;">
        <va-card-content>
          <SuperUserManagement />
        </va-card-content>
      </va-card>
      <va-card>
        <va-card-content>
          <div class="flex xs12 dropdown-container">
            <p class="flex xs12 group-title">Group selection</p>
            <div class="dropdown">
              <SearchDropdown :options="industryOptions" v-on:selected="industrySelected" name="industry" label="Industry"
                placeholder="Please select an industry">
              </SearchDropdown>
            </div>
            <div class="dropdown">
              <SearchDropdown :options="this.filteredAdminEntityList" v-on:selected="entitySelected" name="school"
                label="School" placeholder="Please select an school">
              </SearchDropdown>
            </div>
            <div class="dropdown">
              <SearchDropdown :options="this.adminGroupList" v-on:selected="groupSelected" name="group" label="Group"
                placeholder="Please select a group">
              </SearchDropdown>
            </div>
          </div>
        </va-card-content>
      </va-card>

      <va-card :title="'Group details'">
        <va-card-content>
          <div class="flex xs12 dropdown-container">
            <p class="flex xs12 group-title"></p>
            <AdminUserGroup :userGroupData="adminUserGroupJsonData" :selected_user_group="selected_user_group"
              @add_user_to_usergroup="add_user_to_usergroup" @remove_user_from_usergroup="remove_user_from_usergroup"
              @add_permission_to_usergroup="add_permission_to_usergroup"
              @remove_permission_from_usergroup="remove_permission_from_usergroup"
              @openEditGroupModal="openEditGroupModal" @remove_usergroup="remove_usergroup" @invite_user="invite_user">
            </AdminUserGroup>
          </div>

        </va-card-content>
      </va-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SuperUserManagement from '@/modules/admin/components/SuperUserManagement'
import AdminUserGroup from '@/modules/admin/components/AdminUserGroup'
import SearchDropdown from '@/modules/shared/SearchDropdown'
import InviteUserModal from '@/modules/admin/components/InviteUserModal'
import EditReportModal from '@/modules/admin/components/EditReportModal'
import AddGroupModal from '@/modules/admin/components/AddGroupModal'

export default {
  name: 'admin',
  components: {
    SuperUserManagement,
    SearchDropdown,
    AdminUserGroup,
    AddGroupModal,
    InviteUserModal
  },
  methods: {},
  watch: {},
  created() { },
  data() {
    return {
      isOpen: false,
      showAddGroupModal: false,
      showInviteUserModal: false,
      selected_user_group: {
        industry_value: 1,
        entity_value: 0,
        user_group_value: 0
      },
      usergroupData: {
        profile: {
          value: 'group1',
          label: 'admin team'
        },
        selected_users: [
          {
            value: 'fred.gu@findex.com.au', //? why this user is hardcoded ? 
            label: 'fred.gu@findex.com.au' //? why is this user hardcoded ? 
          }
        ],
        available_users: [
          {
            value: 'thao@findex.com.au',
            label: 'thao@findex.com.au'
          },
          {
            value: 'nathan.curiale@findex.com.au',
            label: 'nathan.curiale@findex.com.au'
          }
        ],
        selected_permissions: [
          {
            value: 'permission1',
            label: 'permission1'
          }
        ],
        available_permissions: [
          {
            value: 'permission2',
            label: 'permission2'
          },
          {
            value: 'permission3',
            label: 'permission3'
          }
        ]
      },
      industryOptions: [{ id: 1, name: 'Education' }],
      filteredAdminEntityList: [],
      editGroup: null,
      title: '',
      inviteUser: null
    }
  },
  computed: {
    ...mapState({
      adminTreeJsonData: state => state.admin.adminTreeJsonData,
      adminUserGroupJsonData: state => state.admin.adminUserGroupJsonData,
      adminEntityList: state => state.admin.adminEntityList ? state.admin.adminEntityList.entities : [],
      adminGroupList: state => state.admin.adminGroupList ? state.admin.adminGroupList.groups : [],
      selectedEntity: state => state.user.selectedEntity,
      canSendSpecialUserInvite: state => state.user.isSuperUser
    })
  },
  created() {
    //start loading animation

    if (this.selectedEntity.id > 0) {
      this.getAdminEntityList({ 'entityId': this.selectedEntity.id })
      this.filteredAdminEntityList = this.adminEntityList.filter(e => e.id === this.selectedEntity.id);
    }


  },
  watch: {
    adminTreeJsonData(new_value) {
      if (new_value !== null && new_value !== undefined) {
        if (new_value['entities'].length > 0) {
          if (new_value['entities'][0]['user_groups'].length > 0) {
            this.selected_user_group.industry_value = new_value['value']
            this.selected_user_group.entity_value = new_value['entities'][0]['value']
            this.selected_user_group.user_group_value = new_value['entities'][0]['user_groups'][0]['value']

            const param = {
              'industry_id': this.selected_user_group.industry_value,
              'entity_id': this.selected_user_group.entity_value,
              'usergroup_id': this.selected_user_group.user_group_value
            }

            this.loadAdminUserGroupJsonData(param)
          }
        }

      }
    },
    selected_user_group(new_value) {
      if (new_value !== null && new_value !== undefined && new_value.user_group_value !== null) {

        const param = {
          'industry_id': new_value.industry_value,
          'entity_id': new_value.entity_value,
          'usergroup_id': new_value.user_group_value
        }
        this.loadAdminUserGroupJsonData(param)
      }
    },
    adminEntityList(new_value) {
      if (new_value !== null && new_value !== undefined) {
        this.filteredAdminEntityList = this.adminEntityList.filter(e => e.id === this.selectedEntity.id);
      }
    }
  },
  methods:
  {
    ...mapActions({
      loadAdminTreeJsonData: "admin/getAdminTreeJsonData",
      loadAdminUserGroupJsonData: "admin/getAdminUserGroupJsonData",
      addUserToUserGroup: "admin/addUserToUserGroup",
      removeUserToUserGroup: "admin/removeUserToUserGroup",
      addPermissionToUserGroup: "admin/addPermissionToUserGroup",
      removePermissionFromUserGroup: "admin/removePermissionFromUserGroup",
      getAdminEntityList: "admin/getAdminEntityList",
      getAdminGroupList: "admin/getAdminGroupList",
      clearAdminGroupList: "admin/clearAdminGroupList",
      clearAdminUserGroupJsonData: "admin/clearAdminUserGroupJsonData",
      deleteUserGroup: "admin/deleteUserGroup",
      // deleteReport: "admin/deleteReport",
      getReportList: "report/getReportList"
    }),
    update_user_group(input_param) {
      this.selected_user_group = input_param
    },
    add_user_to_usergroup(input_param) {
      const param = {}
      param['industry_id'] = this.selected_user_group.industry_value
      param['entity_id'] = this.selected_user_group.entity_value
      param['usergroup_id'] = input_param['usergroup_id']
      param['user_id'] = input_param['user_id']
      this.addUserToUserGroup(param)
    },
    remove_user_from_usergroup(input_param) {
      const param = {}
      param['industry_id'] = this.selected_user_group.industry_value
      param['entity_id'] = this.selected_user_group.entity_value
      param['usergroup_id'] = input_param['usergroup_id']
      param['user_id'] = input_param['user_id']
      this.removeUserToUserGroup(param)
    },
    add_permission_to_usergroup(input_param) {
      const param = {}
      param['industry_id'] = this.selected_user_group.industry_value
      param['entity_id'] = this.selected_user_group.entity_value
      param['usergroup_id'] = input_param['usergroup_id']
      param['permission_id'] = input_param['permission_id']
      this.addPermissionToUserGroup(param)
    },
    remove_permission_from_usergroup(input_param) {
      const param = {}
      param['industry_id'] = this.selected_user_group.industry_value
      param['entity_id'] = this.selected_user_group.entity_value
      param['usergroup_id'] = input_param['usergroup_id']
      param['permission_id'] = input_param['permission_id']
      this.removePermissionFromUserGroup(param)
    },
    entitySelected(e) {
      if (e && e.id) {
        if (e.id !== this.selected_user_group.entity_value) {
          this.selected_user_group.entity_value = e.id;
          this.getAdminGroupList({ 'entityId': this.selected_user_group.entity_value });
          this.clearAdminGroupList();
          this.clearAdminUserGroupJsonData();
        }
      }
    },
    groupSelected(e) {
      if (e && e.id) {
        if (e.id !== this.selected_user_group.user_group_value) {
          this.selected_user_group.user_group_value = e.id;
          const param = {
            'industry_id': 0,
            'entity_id': this.selected_user_group.entity_value,
            'usergroup_id': this.selected_user_group.user_group_value
          }
          this.loadAdminUserGroupJsonData(param)
        }
      }
    },
    industrySelected(e) {
    },
    close() {
      this.showCreateReportModal = false
      this.showAddGroupModal = false
      this.showInviteUserModal = false
    },
    openEditGroupModal(modalInfo) {
      this.showAddGroupModal = !this.showAddGroupModal;
      this.title = modalInfo.operation.toLowerCase() === 'edit' ? `${modalInfo.operation} User Group: ${modalInfo.profile.label}` : `${modalInfo.operation} User Group`;
      const groupId = modalInfo.operation.toLowerCase() === 'edit' ? this.selected_user_group.user_group_value : 0;

      this.editGroup = {
        title: this.title,
        industry_id: this.selected_user_group.industry_value,
        entity_id: this.selected_user_group.entity_value,
        usergroup_id: groupId,
        usergroup_name: modalInfo.profile ? modalInfo.profile.label : '',
        usergroup_description: modalInfo.profile ? modalInfo.profile.description : ''
      };
    },
    remove_usergroup(input_param) {
      this.deleteUserGroup(input_param);
      this.clearAdminGroupList();
      this.clearAdminUserGroupJsonData();
    },
    invite_user() {
      this.showInviteUserModal = !this.showInviteUserModal;
      this.inviteUser = {
        title: 'Invite User',
        options: this.adminEntityList,
        selectedEntity: this.selected_user_group.entity_value
      }
    },
    openEditReportModal(modalInfo) {
    },
    removeReport(param) {
    }
  }
}
</script>

<style scoped>
.grid.row {
  overflow: hidden !important
}

.dropdown-container {
  display: flex;
  flex-wrap: wrap;
  border: none;
  border-radius: 0.375rem;
  background: white;
  color: #000;
}

.dropdown {
  margin: 5px;
}

.outer-container {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.row.row-equal.outer-container+.row.row-equal.outer-container {
  margin-top: 15px;
}

.group-title {
  float: left;
  font-weight: 600;
  padding: 0 !important;
}
</style>